<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [markers]="chartOptions.markers!"
        [stroke]="chartOptions.stroke!"
        [dataLabels]="chartOptions.dataLabels!"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [grid]="chartOptions.grid!"
        [colors]="chartOptions.colors!"
        [title]="chartOptions.title!"
    ></apx-chart>
</div>